import GenerateAiArt from "../GenerateAiArt";
import KeyValueForm from "./KeyValue";
import BannerImg from "../../Assets/images/banner-right-img.png";

const JsonGenarator = () => {
  return (
    <>
      <section className="mainSection">
        <div className="container">
          <div className="row firstSection">
            <div className="col-md-6 col-sm-12 bannerLeft">
              <h2 className="title">Create NFT’s with AI</h2>
              <h5 className="subText">
                Generate AI art simply by describing what you want to see and
                make it an NFT. Mint as many as you want.
              </h5>
              {/* <div className='bannerBtnSect mt-50 mb-50'> 
                                <div className='countSect btn'>
                                    <button> - </button>
                                    <input type="text" placeholder='1'/>
                                    <button> + </button>
                                </div>
                                <button className='btn'>Start NFT </button>
                            </div> */}
            </div>
            <div className="col-md-6 col-sm-12">
              <img style={{ width: "100%" }} src={BannerImg} />
            </div>
          </div>
        </div>
      </section>
      <GenerateAiArt />
      <section className={`mainSection `}>
        <div className="container">
          <div className="row ">
            <div className="col-md-6 col-sm-12 ">
              <h3>JSON Generate</h3>

              <br />
              <KeyValueForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default JsonGenarator;
